import { useEffect, useMemo, useRef, useState } from "react";
import CustomScroller from "../CustomScroller/CustomScroller";
import classes from "./CustomDatePicker.module.css";
import ClearIcon from "@mui/icons-material/Clear";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { ReactComponent as CalendarMonthIcon } from "../../../images/icons/forms/datePickerIcon.svg";
import ValidationErrors from "../ValidationErrors/ValidationErrors";
import validate from "../../../utils/validations/validateV2";
import checkFieldDisabledStatus from "../../../utils/accessUtils/checkFieldDisabledStatus";
import extractFieldValidations from "../../../utils/accessUtils/extractFieldValidations";

const monthItems = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];
const dayItemsfirsthalfYear = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
];
const dayItemsSecondhalfYear = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
];
const dayItemslastMounth = [
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
];
const CustomDatePicker = ({
  changeDateHandler,
  value,
  label,
  style,
  yearOptions,
  showDeleteBtn,
  openOnCurrentDate = true,
  fieldAccesses,
  fieldNames,
  fieldName,
  disabled,
  processualDisabled,
  pageIsProcessual,
  entityIsProcessual,
  skipStateCanEditThisFieldCheck,
  forceLtr,
  validityName,
  defultDate,
  currentState,
  fromYear,
  toYear = 1450,
  fieldAddress,
  indexArr,
  forceEn,
  confirmActionOrder,
  localValidationInfos = {},
  validateHandler,
  uniqueId,
  onFocus,
  onBlur,
  skipFieldAccessCheck,
  isMongoField,
  hasSQLEntity,
  mongoFieldPath,
  withStar = true,
}) => {
  let currentSolarDateArray = new Date()
    .toLocaleDateString("fa-IR-u-nu-latn")
    .split("/")
    ?.map((each) => {
      if (each.length < 2) {
        return `0${each}`;
      } else {
        return each;
      }
    });
  let fYear = fromYear ? fromYear : 1300;
  let tYear = toYear ? toYear : currentSolarDateArray[0];
  const createYears = () => {
    let years = [];
    for (let i = fYear; i < tYear; i++) {
      years.push(i + 1);
    }
    return years;
  };
  const yearItems = yearOptions ? yearOptions : createYears();
  // let defaultDateArray = "1390-10-14";

  let defaultDateArray = openOnCurrentDate
    ? currentSolarDateArray.join("-")
    : defultDate
      ? defultDate
      : "1377-10-14";

  let dateArray = value ? value.split("-") : defaultDateArray.split("-");

  // const yearItem =
  //   yearItems.findIndex((year) => {
  //     return year === +dateArray[0];
  //   }) + 1;
  // const monthItem =
  //   monthItems.findIndex((month) => {
  //     return month === dateArray[1];
  //   }) + 1;
  // const dayItem =
  //   monthItem < 7
  //     ? dayItemsfirsthalfYear.findIndex((year) => {
  //         return year === dateArray[2];
  //       }) + 1
  //     : monthItem == 12
  //     ? dayItemslastMounth.findIndex((year) => {
  //         return year === dateArray[2];
  //       }) + 1
  //     : dayItemsSecondhalfYear.findIndex((year) => {
  //         return year === dateArray[2];
  //       }) + 1;

  const [openDatePickerModal, setOpenDatePickerModal] = useState(false);
  const [totalValue, setTotalValue] = useState(
    value
      ? value
      : openOnCurrentDate
        ? currentSolarDateArray.join("-")
        : defultDate
          ? defultDate
          : "1377-10-14",
  );

  const { disabled: fieldIsDisabled, processualDisabled: fieldIsProcessualDisabled } = useMemo(
    () =>
      checkFieldDisabledStatus({
        fieldAccesses,
        fieldName,
        pageIsProcessual,
        disabledFromParent: disabled,
        processualDisabledFromParent: processualDisabled,
        currentState,
        entityIsProcessual,
        skipStateCanEditThisFieldCheck,
        isMongoField,
        hasSQLEntity,
        mongoFieldPath: mongoFieldPath ? mongoFieldPath : fieldAddress ? fieldAddress : null,
      }),
    [fieldAccesses, disabled, processualDisabled, currentState],
  );
  const readOnly = skipFieldAccessCheck ? disabled : fieldIsDisabled || fieldIsProcessualDisabled;
  const { inWhichStateOrderItBecomesNecessary, validationType, isMandatory } = useMemo(
    () =>
      extractFieldValidations({
        fieldAccesses,
        fieldName,
      }),
    [fieldAccesses],
  );

  const [shouldSetDefaultValue, setShouldSetDefaultValue] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const yearItem =
    yearItems.findIndex((year) => {
      return year === +totalValue.split("-")[0];
    }) + 1;
  const monthItem = monthItems.findIndex((month) => {
    // console.log(totalValue.split("-")[1]);
    // console.log(monthItems[+totalValue.split("-")[1] - 1]);
    return month === monthItems[+totalValue.split("-")[1] - 1];
  });
  const dayItem =
    monthItem < 7
      ? dayItemsfirsthalfYear.findIndex((year) => {
          return year === totalValue.split("-")[2];
        }) + 1
      : monthItem == 12
        ? dayItemslastMounth.findIndex((year) => {
            return year === totalValue.split("-")[2];
          }) + 1
        : dayItemsSecondhalfYear.findIndex((year) => {
            return year === totalValue.split("-")[2];
          }) + 1;

  useEffect(() => {
    setTotalValue(
      value
        ? value
        : openOnCurrentDate
          ? currentSolarDateArray.join("-")
          : defultDate
            ? defultDate
            : "1377-10-14",
    );
    setShouldSetDefaultValue(true);
  }, [value]);
  const changeHandlerDay = (val) => {
    setTotalValue((ps) => {
      const dateArray = ps.split("-");
      dateArray[2] = dateArray[1] < 7 ? dayItemsfirsthalfYear[val - 1] : dayItemsSecondhalfYear[val - 1];
      const dateNewStr = dateArray.join("-");
      return dateNewStr;
    });
  };
  const changeHandlerMonth = (val) => {
    setTotalValue((ps) => {
      const dateArray = ps.split("-");
      dateArray[1] = val < 10 ? `0${val}` : val;

      if (val > 6 && val < 12) {
        if (dateArray[2] == 31) {
          dateArray[2] = 30;
          setShouldSetDefaultValue(true);
        }
      } else if (val == 12) {
        if (dateArray[2] > 29) {
          dateArray[2] = 29;
          setShouldSetDefaultValue(true);
        }
        setShouldSetDefaultValue(true);
      }

      const dateNewStr = dateArray.join("-");
      return dateNewStr;
    });
  };
  const changeHandlerYear = (val) => {
    setTotalValue((ps) => {
      const dateArray = ps.split("-");
      dateArray[0] = yearItems[val - 1];
      const dateNewStr = dateArray.join("-");
      return dateNewStr;
    });
  };

  const changeHandlerOpenDatePicker = () => {
    if (onBlur) onBlur(totalValue, fieldAddress);
    document.body.style.setProperty("overflow-y", "scroll", "important");
    setOpenDatePickerModal(false);
    changeDateHandler(totalValue, fieldAddress);

    if (
      validationType ||
      isMandatory ||
      Object.keys(localValidationInfos).length > 0 ||
      !validityName?.isValid
    ) {
      if (validateHandler) {
        const validateOptions = { ...localValidationInfos };
        if (isMandatory) {
          validateOptions.isOptional = false;
        } else {
          validateOptions.isOptional = true;
        }
        if (validationType) validateOptions.type = validationType;
        if (inWhichStateOrderItBecomesNecessary)
          validateOptions.inWhichStateOrderItBecomesNecessary = inWhichStateOrderItBecomesNecessary;
        if (confirmActionOrder) validateOptions.clickedActionOrder = confirmActionOrder;
        if (forceEn) validateOptions.forceLtr = forceEn;
        validateOptions.data = totalValue;

        const newValue = validate(validateOptions);
        validateHandler(newValue, fieldAddress, indexArr);
      }
    }

    document.body.style.overflow = "unset";
  };
  const changeHandlerOpenDatePickerr = () => {
    document.body.style.setProperty("overflow-y", "scroll", "important");
    setOpenDatePickerModal(false);
    if (onBlur) onBlur(value, fieldAddress);
  };
  const deleteDateHandler = (e) => {
    e.stopPropagation();
    if (value) {
      changeDateHandler(null, fieldAddress);
      if (
        validationType ||
        isMandatory ||
        Object.keys(localValidationInfos).length > 0 ||
        !validityName?.isValid
      ) {
        if (validateHandler) {
          const validateOptions = { ...localValidationInfos };
          if (isMandatory) {
            validateOptions.isOptional = false;
          } else {
            validateOptions.isOptional = true;
          }
          if (validationType) validateOptions.type = validationType;
          if (inWhichStateOrderItBecomesNecessary)
            validateOptions.inWhichStateOrderItBecomesNecessary = inWhichStateOrderItBecomesNecessary;
          if (confirmActionOrder) validateOptions.clickedActionOrder = confirmActionOrder;
          if (forceEn) validateOptions.forceLtr = forceEn;
          validateOptions.data = null;

          const newValue = validate(validateOptions);
          validateHandler(newValue, fieldAddress, indexArr);
        }
      }
    }
  };
  const modalRef = useRef(null);
  const scrollYRef = useRef(0);
  // useEffect(() => {
  //   if (openDatePickerModal) {
  //     const currentScrollY = window.scrollY;
  //     setScrollY(currentScrollY); // ذخیره موقعیت اسکرول مخصوص این مدال
  //     document.body.style.position = "fixed";
  //     document.body.style.top = `-${currentScrollY}px`;
  //     document.body.style.width = "100%";

  //     // فوکوس روی مدال
  //     if (modalRef.current) {
  //       modalRef.current.focus();
  //     }
  //   } else {
  //     // بازگشت به موقعیت اسکرول قبلی
  //     document.body.style.position = "";
  //     document.body.style.top = "";
  //     document.body.style.width = "";
  //     window.scrollTo(0, scrollY); // اسکرول به نقطه‌ی قبلی مخصوص این مدال
  //   }

  //   return () => {
  //     // بازگردانی به حالت اولیه در زمان بسته شدن مدال
  //     document.body.style.position = "";
  //     document.body.style.top = "";
  //     document.body.style.width = "";
  //   };
  // }, [openDatePickerModal]);

  useEffect(() => {
    if (openDatePickerModal) {
      const disableScroll = (e) => e.preventDefault();

      document.addEventListener("touchmove", disableScroll, { passive: false });

      return () => {
        document.removeEventListener("touchmove", disableScroll);
      };
    }
  }, [openDatePickerModal]);
  return (
    <div
      className={[
        classes.mainDatePicker,
        style === "tableSearch"
          ? classes.tableSearchMainDatePicker
          : style === "tableInsert"
            ? classes.tableInsertMainDatePicker
            : null,
      ].join(" ")}
    >
      <div
        className={
          readOnly
            ? [
                classes.disabled,
                "disabledPInput",
                "pLabelDown",
                style === "tableSearch" ? classes.tsInput : "",
              ].join(" ")
            : [
                style === "tableSearch" ? classes.tsInput : classes.Input,
                (validityName && validityName?.isValid) || !validityName
                  ? "enabledPInput"
                  : "invalidPInput",
                style === "tableSearch"
                  ? classes.tableSearchInput
                  : style === "tableInsert"
                    ? classes.tableInsertInput
                    : null,
                "pLabelDown",
              ].join(" ")
        }
        onClick={() => {
          if (!readOnly) {
            document.body.style.setProperty("overflow-y", "hidden", "important");
            // console.log("first");
            setOpenDatePickerModal(true);
            if (onFocus) onFocus(value, fieldAddress);

            setShouldSetDefaultValue(true);
          }
        }}
      >
        {style === "tableInsert" ? (
          <div
            className={[
              [classes.tableInsertLabel, "enabledinputPLabel"].join(" "),
              value
                ? [classes.labelUp, "pLabelUp"].join(" ")
                : [classes.labelDown, "pLabelDown"].join(" "),
            ].join(" ")}
          >
            {label}
          </div>
        ) : style === "tableSearch" ? null : (
          <div
            className={
              readOnly
                ? [
                    classes.labeldis,
                    "disabledinputPLabel",
                    value
                      ? [classes.labelUp, "pLabelUp"].join(" ")
                      : [classes.labelDown, "pLabelDown"].join(" "),
                  ].join(" ")
                : [
                    classes.label,
                    value
                      ? [classes.labelUp, "pLabelUp"].join(" ")
                      : [classes.labelDown, "pLabelDown"].join(" "),
                    (validityName && validityName?.isValid) || !validityName
                      ? "enabledinputPLabel"
                      : "invalidinputPLabel",
                  ].join(" ")
            }
          >
            {label}
            {withStar
              ? isMandatory || localValidationInfos?.type === "mandatory"
                ? " * "
                : null
              : null}
            {/* {isMandatory ? <span className={classes.mandatorySign}>*</span> : null} */}
          </div>
        )}
        {!readOnly && showDeleteBtn && value ? ( // ????? && value is just added ?????
          <span
            className={[
              classes.deleteBtnContainer,
              style === "tableSearch" ? classes.tableDeleteIcon : null,
            ].join(" ")}
          >
            <ClearIcon onClick={deleteDateHandler} className={classes.clearIcon} />
          </span>
        ) : null}
        {style === "tableSearch" && value === "" ? (
          <span className={["pLabelPlaceholder", "enabledinputPLabel"].join(" ")}>
            {forceLtr ? (label ? label : "Search") : label ? label : "جست و جو"}
          </span>
        ) : null}
        {style === "tableSearch" ? (
          value ? (
            <p
              className={[
                readOnly ? "disabledInpotColor" : "enabledinputPLabel",
                style === "tableSearch"
                  ? "pLabelSmall"
                  : readOnly
                    ? ["pLabelDown", classes.InputValue].join(" ")
                    : classes.InputValue,
                style === "tableInsert" ? classes.tableInsertInputValue : null,
              ].join(" ")}
            >
              {value}
            </p>
          ) : null
        ) : (
          <p
            className={[
              readOnly ? "disabledInpotColor" : "enabledinputPLabel",
              style === "tableSearch"
                ? "pLabelDown"
                : readOnly
                  ? ["pLabelDown", classes.InputValue].join(" ")
                  : classes.InputValue,
              style === "tableInsert" ? classes.tableInsertInputValue : null,
            ].join(" ")}
          >
            {value}
          </p>
        )}
        {(style === "tableSearch" && value === "") || style !== "tableSearch" ? (
          <div
            className={[
              readOnly ? "disabledinputPLabel" : classes.icon,
              (validityName && validityName?.isValid) || !validityName
                ? "enabledinputPLabel"
                : "invalidinputPLabel",
              style === "tableSearch" ? classes.tableSearchIcon : null,
            ].join(" ")}
          >
            <CalendarMonthIcon className={classes.calendarIcon} />
          </div>
        ) : null}
      </div>
      {openDatePickerModal ? (
        <>
          <div className={classes.backdrop} onClick={changeHandlerOpenDatePickerr}></div>
          <div
            className={[
              classes.optionsDatepicker,
              style === "tableSearch" || style === "tableInsert"
                ? classes.tableSearchOptionsDatepicker
                : null,
            ].join(" ")}
            ref={modalRef}
            tabIndex="-1"
          >
            <div className={classes.datePickerLables}>
              {/* <div className={classes.datePickerLable}>روز</div>
              <div className={classes.datePickerLable}>ماه</div>
              <div className={classes.datePickerLable}>سال</div> */}
              <div>{label}</div>
            </div>
            <div className={classes.options}>
              <CustomScroller
                style={style}
                value={dayItem}
                onChange={changeHandlerDay}
                shouldSetDefaultValue={shouldSetDefaultValue}
                items={
                  totalValue.split("-")[1] < 7
                    ? dayItemsfirsthalfYear
                    : totalValue.split("-")[1] == 12
                      ? dayItemslastMounth
                      : dayItemsSecondhalfYear
                }
                setShouldSetDefaultValue={setShouldSetDefaultValue}
              />
              <CustomScroller
                style={style}
                value={monthItem + 1}
                onChange={changeHandlerMonth}
                shouldSetDefaultValue={shouldSetDefaultValue}
                items={monthItems}
                setShouldSetDefaultValue={setShouldSetDefaultValue}
              />
              <CustomScroller
                style={style}
                value={yearItem}
                onChange={changeHandlerYear}
                shouldSetDefaultValue={shouldSetDefaultValue}
                items={yearItems}
                setShouldSetDefaultValue={setShouldSetDefaultValue}
              />
            </div>
            <div className={classes.footerDatePicker}>
              <button
                className={[classes.btnDatePicker, "pLabelDown"].join(" ")}
                onClick={changeHandlerOpenDatePicker}
              >
                تأیید
              </button>
            </div>
          </div>
        </>
      ) : null}
      <input
        name={uniqueId ? uniqueId : "fileInput"}
        className={classes.fileInput}
        id={uniqueId ? uniqueId : "fileInput"}
        disabled={readOnly}
        onFocus={(e) => {
          if (!readOnly) {
            if (onFocus) onFocus(value, fieldAddress);
            document.body.style.setProperty("overflow-y", "hidden", "important");
            // console.log("first");
            setOpenDatePickerModal(true);
          }
        }}
      />
      {validityName ? (
        <ValidationErrors validity={validityName.isValid} message={validityName.msg} />
      ) : null}
    </div>
  );
};

export default CustomDatePicker;
